
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcasts/category/[slug]",
      function () {
        return require("private-next-pages/podcasts/category/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcasts/category/[slug]"])
      });
    }
  